import styled from 'styled-components';

import { ProfileImage as ProfileImageComponent } from '@xingternal/profile-image';
import { spaceM, spaceXS } from '@xingternal/tokens';

import { lineClamp } from '@/utils/line-clamp';

export const Title = styled.div`
  ${lineClamp(2)};
  margin-bottom: ${spaceXS};
`;

export const ProfileImage = styled(ProfileImageComponent)`
  margin-bottom: ${spaceM};
`;
